export class DTOUserEmail {
    Email: string;
}
